import { render, staticRenderFns } from "./OrderPaymentDetailSection.vue?vue&type=template&id=0087195b&scoped=true&"
import script from "./OrderPaymentDetailSection.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentDetailSection.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentDetailSection.vue?vue&type=style&index=0&id=0087195b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0087195b",
  null
  
)

export default component.exports